import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";
import { mat4 } from "_src/libs/gl-matrix";

import vertText from "_src/shaders/update_depth/update_depth.glslv";
import fragText from "_src/shaders/update_depth/update_depth.glslf";

const _mat4Tmp = mat4.create();

export default class UpdateDepthShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.writeDepth = true;

    this.attachUniforms();

  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms() {
    this.uniforms["u_text_depth"] = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
    this.uniforms["u_text_object_id"] = new Uniform(uniformType.INT1, 1, uniformSource.OBJECT);
    this.uniforms["u_from_proj_matrix_inv"] = new Uniform(uniformType.MAT4, mat4.create());
    this.uniforms["u_to_proj_matrix"] = new Uniform(uniformType.MAT4, mat4.create());
  }

  setProjectionMatrices(fromMatrix, toMatrix) {
    const ivnProjMat = mat4.invert(_mat4Tmp, fromMatrix);
    mat4.copy(this.uniforms["u_from_proj_matrix_inv"].value, ivnProjMat);
    mat4.copy(this.uniforms["u_to_proj_matrix"].value, toMatrix);
  }


}
